import React, { useState, useEffect } from 'react';
import { useMutation, gql } from '@apollo/client';
import jsPDF from 'jspdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';

const ACTUALIZAR_STOCK = gql`
  mutation editarProducto(
    $id: ID!
    $nuevoNombre: String
    $nuevaImagen: String
    $nuevoCodigo: String
    $nuevoStock: Int
    $nuevoPrecio: Decimal
  ) {
    editarProducto(
      _id: $id
      nombre: $nuevoNombre
      imagen: $nuevaImagen
      codigo: $nuevoCodigo
      stock: $nuevoStock
      precio: $nuevoPrecio
    ) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;

const NUEVO_PEDIDO = gql`
  mutation crearPedido(
    $estado: String
    $fecha: Date
    $nombreCliente: String
    $direccionCliente: String
    $whatsappCliente: String
    $notaPedido: String
    $productos: String
  ) {
    crearPedido(
      estado: $estado
      fecha: $fecha
      nombreCliente: $nombreCliente
      direccionCliente: $direccionCliente
      whatsappCliente: $whatsappCliente
      notaPedido: $notaPedido
      productos: $productos
    ) {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

// 📅 Fecha local GMT-5 (Colombia)
function fechaISOColombia() {
  const ahora = new Date();
  const offset = -5 * 60;
  const localISO = new Date(ahora.getTime() + offset * 60000).toISOString();
  return localISO;
}

function FinalizarCompra1() {
  const [estado] = useState('esperando');
  const [fecha, setFecha] = useState(fechaISOColombia());
  const [nombreCliente, setNombreCliente] = useState('');
  const [direccionCliente, setDireccionCliente] = useState('');
  const [whatsappCliente, setWhatsappCliente] = useState('');
  const [notaPedido, setNotaPedido] = useState('');
  const [carritoLocal, setCarritoLocal] = useState([]);
  const [contactosGuardados, setContactosGuardados] = useState([]);

  const [nuevoPedido] = useMutation(NUEVO_PEDIDO);
  const [actualizarStock] = useMutation(ACTUALIZAR_STOCK);

  // Cargar carrito y contactos guardados
  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito1')) || [];
    setCarritoLocal(carritoGuardado);

    const contactosPrevios = JSON.parse(localStorage.getItem('contactosClientes')) || [];
    setContactosGuardados(contactosPrevios);

    setFecha(fechaISOColombia());
  }, []);

  const handleCompraClick = async () => {
    for (const producto of carritoLocal) {
      const { _id, nombre, imagen, codigo, precio, stock, cantidad } = producto;
      await actualizarStock({
        variables: {
          id: _id,
          nuevoNombre: nombre,
          nuevaImagen: imagen,
          nuevoCodigo: codigo,
          nuevoPrecio: precio,
          nuevoStock: stock - cantidad,
        },
      });
    }
    localStorage.removeItem('carrito1');
    setCarritoLocal([]);
  };

  const generarMensajeWhatsapp = () => {
    let mensaje = `*Hola, para ver su compra ingresa al siguiente enlace:*\n`;
    mensaje += `*https://factura.campofruver.com*\n`;
    mensaje += `Agrega los siguientes datos: *codigo: ${notaPedido} contacto: ${whatsappCliente}*\n`;
    return encodeURIComponent(mensaje);
  };

  const generarPDF = () => {
    const doc = new jsPDF();
    doc.text(`Cliente: ${nombreCliente}`, 10, 20);
    doc.text(`Dirección: ${direccionCliente}`, 10, 30);
    doc.text(`WhatsApp: ${whatsappCliente}`, 10, 40);
    doc.text('Detalles de la compra', 10, 50);
    carritoLocal.forEach((producto, i) => {
      doc.text(`${producto.nombre} - Cant: ${producto.cantidad} - $${producto.precio}`, 10, 60 + i * 10);
    });
    doc.save('pedido.pdf');
  };

  const pedidoSubmit = async (e) => {
    e.preventDefault();
    const carritoString = JSON.stringify(carritoLocal);

    await nuevoPedido({
      variables: {
        estado,
        fecha,
        nombreCliente,
        direccionCliente,
        whatsappCliente,
        notaPedido,
        productos: carritoString,
      },
    });

    // ✅ Guardar contacto en localStorage si no existe
    const contactosPrevios = JSON.parse(localStorage.getItem('contactosClientes')) || [];
    if (!contactosPrevios.includes(whatsappCliente)) {
      const nuevosContactos = [...contactosPrevios, whatsappCliente];
      localStorage.setItem('contactosClientes', JSON.stringify(nuevosContactos));
      setContactosGuardados(nuevosContactos);
    }

    handleCompraClick();
    generarPDF();

    const numeroWhatsApp = `57${whatsappCliente}`;
    const mensaje = generarMensajeWhatsapp();
    const enlaceWhatsApp = `https://web.whatsapp.com/send?phone=${numeroWhatsApp}&text=${mensaje}`;
    window.open(enlaceWhatsApp, 'whatsappWindow');

    setNombreCliente('');
    setDireccionCliente('');
    setWhatsappCliente('');
    setNotaPedido('');
    setFecha(fechaISOColombia());
  };

  return (
    <div>
      {carritoLocal.length === 0 ? (
        <div className="alert alert-success text-center">
          <h4>Agrega productos al carrito</h4>
          <a className="btn btn-success" href="/">
            <FontAwesomeIcon icon={faHouse} />
          </a>
        </div>
      ) : (
        <center>
          <div className="card card-salida col-xs-12 col-xl-4 col-sm-6">
            <div className="card-body">
              <form onSubmit={pedidoSubmit}>
                <input type="hidden" name="estado" value="esperando" />
                <input type="text" name="fecha" value={fecha} readOnly />
                <h3>Código</h3>
                <input
                  placeholder="código único"
                  value={notaPedido}
                  onChange={(e) => setNotaPedido(e.target.value)}
                />

                {/* 🔽 Campo con autocompletado */}
                <input
                  placeholder="Ejemplo: 3010000000"
                  value={whatsappCliente}
                  onChange={(e) => setWhatsappCliente(e.target.value)}
                  list="contactosGuardados"
                />
                <datalist id="contactosGuardados">
                  {contactosGuardados.map((c, i) => (
                    <option key={i} value={c} />
                  ))}
                </datalist>

                <br />
                <button className="btn btn-salida mt-3">Finalizar venta</button>
              </form>
            </div>
          </div>
        </center>
      )}
    </div>
  );
}

export default FinalizarCompra1;
